const agepoids = [
  [0, 3.5],
  [3, 5.2],
  [6, 7.4],
  [8, 8.2],
  [10, 8.8],
  [12, 9.4],
  [18, 10.8],
  [24, 11.8],
  [36, 13.8],
  [60, 17],
  [84, 19],
  [96, 24],
  [108, 27],
  [120, 30],
  [144, 37],
  [168, 47],
  [180, 55],
  [216, 62],
  [360, 60]
];

const poidsage = [
  [2.5, 0],
  [3.5, 0],
  [5.2, 3],
  [7.4, 6],
  [8.2, 8],
  [8.8, 10],
  [9.4, 12],
  [10.8, 18],
  [11.8, 24],
  [13.8, 36],
  [17, 60],
  [19, 84],
  [24, 96],
  [27, 108],
  [30, 120],
  [37, 144],
  [47, 168],
  [55, 180],
  [61.5, 216],
  [999, 216]
];
// Weight-for-length GIRLS    World Health Organisation
const taillepoids = [
  [45, 2.5],
  [50, 3.4],
  [55, 4.5],
  [60, 5.8],
  [65, 7],
  [70, 8.25],
  [75, 9.2],
  [80, 10.1],
  [85, 11.25],
  [90, 12.5],
  [95, 13.75],
  [100, 15],
  [105, 16.5],
  [110, 18.3],
  [115,20],
  [120,22],
  [125,24],
  [130,27],
  [135,30],
  [140,33],
  [145,36],
  [150,40],
  [155,44],
  [160,48.5]
];

//Courbe de corpulence chez les filles de 0 18 ans ProgNatNutSantÃ© Inpes
const IMC = [
  [0, 16],
  [2.5, 16],
  [12, 17.4],
  [36, 16],
  [60, 15.2],
  [72, 15.1],
  [84, 15.2],
  [96, 15.5],
  [108, 15.75],
  [120, 16.25],
  [132, 16.75],
  [144, 17.3],
  [156, 18.15],
  [168, 18.8],
  [180, 19.5],
  [192, 20],
  [204, 20.25],
  [216, 20.35]
];

export class Patient {
  ageYears: number;
  ageMonths: number;
  height: number;
  weight: number;
  totalMonths: number;

  isInsertedAge: boolean;
  isInsertedHeight: boolean;
  isInsertedWeight: boolean;

  computeResults() {
    this.totalMonths = this.computeMonths();
    this.ageYears = this.computeAgeYears();
    this.ageMonths = this.computeAgeMonths();
    this.weight = this.computeWeight();
  }

  computeAgeYears(): number {
    return Math.floor(this.totalMonths / 12);
  }

  computeAgeMonths(): number {
    return this.totalMonths % 12;
  }

  get FC() {
    if (this.totalMonths > 144) {
      return "60-100";
    }
    if (this.totalMonths > 60) {
      return "80-120";
    }
    if (this.totalMonths > 24) {
      return "95-140";
    }
    if (this.totalMonths > 12) {
      return "100-150";
    }
    if (this.totalMonths >= 0) {
      return "110-160";
    }
    return "";
  }
  get TA() {
    if (this.totalMonths > 144) {
      return "90-120";
    }
    if (this.totalMonths > 60) {
      return "80-110";
    }
    if (this.totalMonths > 24) {
      return "70-100";
    }
    if (this.totalMonths > 12) {
      return "70-95";
    }
    if (this.totalMonths >= 0) {
      return "65-90";
    }
    return "";
  }
  get FR() {
    if (this.totalMonths > 144) {
      return "15-20";
    }
    if (this.totalMonths > 60) {
      return "20-25";
    }
    if (this.totalMonths > 24) {
      return "25-30";
    }
    if (this.totalMonths > 12) {
      return "25-35";
    }
    if (this.totalMonths >= 0) {
      return "30-40";
    }
    return "";
  }

  get computedWeight() {
    return 20;
  }

  private computeMonths(): number {
    const monthsFromYears = this.ageYears ? this.ageYears * 12 : 0;
    const monthsFromMonths = this.ageMonths ? this.ageMonths : 0;
    const totalMonths = monthsFromYears + monthsFromMonths;
    if (totalMonths === 0) {
      return this.computeMonthsFromWeightAndHeight();
    }
    return monthsFromYears + monthsFromMonths;
  }

  private computeMonthsFromWeightAndHeight(): number {
    let months;
    if (this.weight !== 0) {
      months = interpole(poidsage, this.weight);
    } else {
      this._computeWeight(this.height, 0);
      const computedWeight = interpole(taillepoids, this.height);
      months = interpole(poidsage, computedWeight);
    }
    return Math.round(months);
  }

  private computeWeight(): number {
    if (this.weight > 0) {
      return this.weight;
    }

    return this._computeWeight(this.height, this.totalMonths);
  }

  private _computeWeight(height, months) {
    let computedWeight;
    if (height == 0 && months > 0) {
      computedWeight = interpole(agepoids, months);
    } else if ( months === 0 && height >= 45 && height <= 110) {
      computedWeight = interpole(taillepoids, height);
    } else {
      computedWeight = (interpole(IMC, months) * height * height) / 10000;
    }
    return computedWeight;
  }

  constructor(patient = {} as Patient) {
    this.ageYears = patient.ageYears;
    this.ageMonths = patient.ageMonths;
    this.height = patient.height;
    this.weight = patient.weight;
    this.isInsertedAge = !!(this.ageYears || this.ageMonths);
    this.isInsertedHeight = !!this.height;
    this.isInsertedWeight = !!this.weight;
  }
}

function interpole(t, x) {
  let i = 0;
  let y;
  while (x > t[i][0]) {
    i++;
  }
  if (i === 0) return t[0][1];
  y =
    (t[i - 1][1] * (t[i][0] - x) + t[i][1] * (x - t[i - 1][0])) /
    (t[i][0] - t[i - 1][0]);
  return y.toFixed(2);
}



// WEBPACK FOOTER //
// ./src/models/patient.model.ts